import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { backend_url } from "../../App";
import "../AddProduct/AddProduct.css";
import upload_area from "../Assets/upload_area.svg";
import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { menuItems } from "../../Constants/menuItems";

const EditProduct = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [productDetails, setProductDetails] = useState({
    name: "",
    unique_id: "",
    description: "",
    category: "",
    subcategory: "",
    new_price: "",
    old_price: "",
    quantity: "",
    scale: "",
    material: "",
    weight: "",
    size: "",
    color: "",
    quality: "",
    disclaimer: "",
    note: "",
    washcare: "",
    images: [],
  });

  const initialProductDetails = {
    name: "",
    description: "",
    unique_id: "",
    category: "",
    subcategory: "unique costume",
    new_price: "",
    old_price: "",
    bestseller: "",
    status: "",
    quantity: "",
    scale: "Meters",
    material: "",
    weight: "",
    size: "",
    color: "",
    quality: "",
    disclaimer: "",
    washcare: "",
    note: "",
    images: [],
  };

  const [images, setImages] = useState([]);

  // Fetch existing product data
  useEffect(() => {
    const fetchProduct = async () => {
      const res = await fetch(`${backend_url}/getproduct/${id}`);
      const data = await res.json();
      if (data.success) {
        setProductDetails(data.product);
        setImages(data.product.images);
      } else {
        toast.error("Failed to load product data");
      }
    };

    fetchProduct();
  }, [id]);

  // Handle form change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setProductDetails((prev) => ({ ...prev, [name]: value }));
  };

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setProductDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  // Handle file upload
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setImages((prev) => [...prev, ...files]);
  };

  // Remove image
  const removeImage = (index) => {
    setImages((prev) => prev.filter((_, i) => i !== index));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();

    // Append all fields
    Object.entries(productDetails).forEach(([key, value]) => {
      if (key !== "images") {
        formData.append(key, value);
      }
    });

    // Append all images
    images.forEach((img) => {
      if (typeof img === "string") {
        formData.append("existingImages", img); // Keep old images as separate field
      } else {
        formData.append("images", img); // New image files
      }
    });

    const res = await fetch(`${backend_url}/editproduct/${id}`, {
      method: "PUT",
      body: formData,
    });

    const data = await res.json();

    if (data.success) {
      toast.success("Product updated successfully", {
        autoClose: 2000,
        transition: Slide,
        onClose: () => navigate("/listproduct"),
      });
    } else {
      toast.error("Failed to update product");
    }
  };

  const changeCategoryHandler = (e) => {
    const { name, value } = e.target;

    setProductDetails((prev) => {
      if (name === "category") {
        return { ...prev, category: value, subcategory: "" };
      }

      if (name === "subcategory") {
        return { ...prev, subcategory: value };
      }

      return prev;
    });
  };

  const getSubcategories = () => {
    const selectedCategory = menuItems.find(
      (item) => item.value === productDetails.category
    );
    if (!selectedCategory) return [];

    // Flatten the subcategories
    return selectedCategory.dropdown.flatMap((sub) => {
      if (sub.subcategories) {
        // Include parent as non-selectable and add nested subcategories
        return [
          { label: sub.label, value: null, isParent: true },
          ...sub.subcategories.map((nested) => ({
            ...nested,
            isNested: true,
          })),
        ];
      }
      return sub;
    });
  };

  const handleCancel = () => {
    setProductDetails(initialProductDetails);
    setImages([]);
    navigate(-1);
  };

  return (
    <>
      <div className="addproduct">
        {/* Product Title */}
        <div className="addproduct-itemfield">
          <p className="product-input-title">Product Name</p>
          <input
            type="text"
            name="name"
            value={productDetails.name}
            onChange={changeHandler}
          />
        </div>

        {/* Product Unique ID */}
        <div className="addproduct-price">
          <div className="addproduct-itemfield">
            <p className="product-input-title">Product Unique Id</p>
            <input
              type="text"
              name="unique_id"
              value={productDetails.unique_id}
              onChange={changeHandler}
              required
            />
          </div>

          {/* Product Quantity */}
          <div className="addproduct-itemfield">
            <p className="product-input-title">Product Quantity</p>
            <input
              type="text"
              name="quantity"
              value={productDetails.quantity}
              onChange={changeHandler}
            />
          </div>
          <div className="addproduct-itemfield">
            <p className="product-input-title">Scalability</p>
            <select
              value={productDetails.scale}
              name="scale"
              className="add-product-selector"
              onChange={changeHandler}
            >
              <option value="Meters">Meters</option>
              <option value="Pcs">Pieces</option>{" "}
            </select>
          </div>
        </div>

        {/* Price and Offer Price */}
        <div className="addproduct-price">
          <div className="addproduct-itemfield">
            <p className="product-input-title">Price</p>
            <input
              type="number"
              name="old_price"
              value={productDetails.old_price ?? 0}
              onChange={changeHandler}
            />
          </div>
          <div className="addproduct-itemfield">
            <p className="product-input-title">Offer Price(%)</p>
            <input
              type="number"
              name="new_price"
              value={productDetails.new_price ?? 0}
              onChange={changeHandler}
            />
          </div>
        </div>

        <div className="addproduct-price">
          {/* Category */}
          <div className="addproduct-itemfield">
            <p className="product-input-title">Product Category</p>
            <select
              value={productDetails.category}
              name="category"
              className="add-product-selector"
              onChange={changeCategoryHandler}
            >
              <option value="">Select Category</option>
              {menuItems.map((item) => (
                <option key={item.value} value={item.value}>
                  {item.label}
                </option>
              ))}
            </select>
          </div>

          {/* Subcategory */}
          <div className="addproduct-itemfield">
            <p className="product-input-title">Product Subcategory</p>
            <select
              value={productDetails.subcategory}
              name="subcategory"
              className="add-product-selector"
              onChange={changeCategoryHandler}
              disabled={!productDetails.category}
            >
              <option value="">Select Subcategory</option>
              {getSubcategories().map((sub) => (
                <option
                  key={sub.value || sub.label}
                  value={sub.value || ""}
                  disabled={sub.isParent}
                  className={
                    sub.isParent
                      ? "option-parent"
                      : sub.isNested
                      ? "option-nested"
                      : "option-child"
                  }
                >
                  {sub.isNested ? `⎯⎯ ${sub.label}` : sub.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Status and Bestseller */}
        <div className="addproduct-price">
          <div className="addproduct-itemfield">
            <p className="product-input-title">Availability</p>
            <select
              value={productDetails.status}
              name="status"
              className="add-product-selector"
              onChange={changeHandler}
            >
              <option value="In-Stock">In-Stock</option>
              <option value="Out of Stock">Out of Stock</option>
              <option value="Low Stock">Low Stock</option>
            </select>
          </div>
          <div className="addproduct-itemfield">
            <p className="product-input-title">Is Bestseller:</p>
            <select
              value={productDetails.bestseller}
              name="bestseller"
              className="add-product-selector"
              onChange={changeHandler}
            >
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </div>
        </div>

        {/* Material & Weight */}
        <div className="addproduct-price">
          <div className="addproduct-itemfield">
            <p className="product-input-title">Material</p>
            <input
              type="text"
              name="material"
              value={productDetails.material}
              onChange={changeHandler}
            />
          </div>
          <div className="addproduct-itemfield">
            <p className="product-input-title">Weight</p>
            <input
              type="text"
              name="weight"
              value={productDetails.weight}
              onChange={changeHandler}
            />
          </div>
          <div className="addproduct-itemfield">
            <p className="product-input-title">Size</p>
            <input
              type="text"
              name="size"
              value={productDetails.size}
              onChange={changeHandler}
            />
          </div>
        </div>

        {/* Size & Quality */}
        <div className="addproduct-price">
          <div className="addproduct-itemfield">
            <p className="product-input-title">Color</p>
            <input
              type="text"
              name="color"
              value={productDetails.color}
              onChange={changeHandler}
            />
          </div>
          <div className="addproduct-itemfield">
            <p className="product-input-title">Quality</p>
            <input
              type="text"
              name="quality"
              value={productDetails.quality}
              onChange={changeHandler}
            />
          </div>
        </div>

        {/* Disclaimer & Washcare */}

        <div className="addproduct-itemfield">
          <p className="product-input-title">Disclaimer</p>
          <input
            type="text"
            name="disclaimer"
            value={productDetails.disclaimer}
            onChange={changeHandler}
          />
        </div>
        <div className="addproduct-itemfield">
          <p className="product-input-title">Washcare</p>
          <input
            type="text"
            name="washcare"
            value={productDetails.washcare}
            onChange={changeHandler}
          />
        </div>

        <div className="addproduct-itemfield">
          <p className="product-input-title">Note</p>
          <input
            type="text"
            name="note"
            value={productDetails.note}
            onChange={changeHandler}
          />
        </div>

        {/* Product Description */}
        <div className="addproduct-itemfield">
          <p className="product-input-title">Product Description</p>
          <textarea
            type="text"
            name="description"
            value={productDetails.description}
            onChange={changeHandler}
          />
        </div>

        {/* Multiple Image Upload */}
        <div className="addproduct-itemfield">
          <p className="product-input-title">Product Images</p>
          <div className="product-image-upload">
            {/* Upload Button */}
            <label htmlFor="file-input">
              <input
                id="file-input"
                type="file"
                multiple
                accept="image/*"
                onChange={handleFileChange}
                hidden
              />
              <img
                className="addproduct-thumbnail-img"
                src={upload_area}
                alt=" 4 Images are allowed"
              />
            </label>

            {/* Display Image Previews */}
            {images.length > 0 && (
              <div className="product-image-preview">
                {images.map((image, index) => (
                  <div key={index} className="image-preview-container">
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      {typeof image === "string" ? (
                        <img
                          src={image}
                          alt="product-image-preview"
                          className="addproduct-thumbnail-img"
                        />
                      ) : (
                        (() => {
                          try {
                            return (
                              <img
                                src={URL.createObjectURL(image)}
                                alt="Preview"
                                className="addproduct-thumbnail-img"
                              />
                            );
                          } catch (error) {
                            console.error("Error creating object URL:", error);
                            return <span>Invalid file</span>;
                          }
                        })()
                      )}
                      <button
                        className="remove-image-btn"
                        onClick={() => removeImage(index)}
                      >
                        <span className="remove-text">Remove</span>
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        <div className="addproduct-actions">
          <button className="cancel-btn" onClick={handleCancel}>
            Cancel
          </button>
          <button className={`addproduct-btn`} onClick={handleSubmit}>
            Update
          </button>
        </div>
      </div>

      <ToastContainer />
    </>
  );
};

export default EditProduct;
